// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-2ljWR","PromoMessage__root":"PromoMessage__root-V65zf","header":"header-3qmoG","service_banner":"service_banner-1sjel"};